import {WBPopupTrigger} from '@wandb/ui';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {WorkspaceTag} from '@wandb/weave/components/Tag/WorkspaceTag';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React from 'react';

import * as FilterTypes from '../../util/filterTypes';
import * as RunTypes from '../../util/runTypes';
import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {RunTagInfiniteDropdown} from '../InfiniteScrollDropdown/RunTagComponents';
import {useRunTagEditor} from './hooks/useRunTagEditor';
import {useRunSelectorFeatureDisabled} from './RunSelectorFeaturesContext';

type AddFilterFn = (
  key: RunTypes.Key,
  op: FilterTypes.ValueOp,
  value: RunTypes.Value
) => void;

type RenderTagsCellProps = {
  entityName: string;
  isGroup: boolean;
  isGroupRun: boolean;
  isHoveringRow: boolean;
  onAddFilter?: AddFilterFn;
  projectName: string;
  row: WBTableRowWithRunSetInfo;
};

export function RunSelectorTagCell({
  entityName,
  isGroup,
  isGroupRun,
  isHoveringRow,
  onAddFilter,
  projectName,
  row,
}: RenderTagsCellProps) {
  const isDisabled = useRunSelectorFeatureDisabled();

  const {addTag, deleteTag} = useRunTagEditor({
    entityName,
    isGroup,
    projectName,
    row,
  });

  if (isGroup && !isGroupRun) {
    return <></>;
  }

  const isTagsReadOnly = isDisabled('tag');
  const isFiltersReadOnly = isDisabled('filter');

  return (
    <Tailwind>
      <div data-test="icon-wrap" className="flex items-center gap-4">
        {row.tags.map((tag, index) => (
          <WorkspaceTag
            key={index}
            tag={tag}
            style={{
              cursor: isTagsReadOnly ? 'unset' : 'pointer',
            }}
            onClick={() => {
              if (!isFiltersReadOnly && onAddFilter) {
                onAddFilter({section: 'tags', name: tag.name}, '=', true);
              }
            }}
            onRemoveClick={
              isTagsReadOnly
                ? undefined
                : (e: React.SyntheticEvent) => {
                    e.stopPropagation();
                    deleteTag(tag.name);
                  }
            }
          />
        ))}
        {!isTagsReadOnly && (
          <WBPopupTrigger
            popupContent={({close}) => (
              <Tailwind>
                <RunTagInfiniteDropdown
                  entityName={entityName}
                  projectName={projectName}
                  isMultiSelect
                  toggleSelection={async tag => {
                    for (const t of row.tags) {
                      if (t.name === tag) {
                        deleteTag(tag);
                        return;
                      }
                    }
                    addTag(tag);
                    close();
                  }}
                  selections={row.tags.map(t => t.name)}
                />
              </Tailwind>
            )}>
            {({anchorRef, setOpen, open}) => {
              return (
                <Button
                  className={clsx('tag-add-button-icon-only', {
                    hidden: !isHoveringRow && !open,
                  })}
                  data-test="tag-add-button"
                  onClick={() => setOpen(!open)}
                  ref={anchorRef}
                  variant="ghost"
                  size="small"
                  icon="add-new"
                  aria-label="Add a new tag"
                  tooltip="Add a new tag"
                />
              );
            }}
          </WBPopupTrigger>
        )}
      </div>
    </Tailwind>
  );
}
